import getApiClient from '@/plugins/api-client'
import Pagination from '@/util/pagination'

export default {
  name: 'PagesList',
  data: () => {
    return {
      pages: [],
      api: null,
      pagination: new Pagination(),
      showDeleteDialog: false,
      deletingId: null,
    }
  },
  mounted: function () {
    this.api = getApiClient(this.$store)

    this.loadPages()
  },
  methods: {
    loadPages: function () {
      const params = this.pagination.getParams()

      this.api.get('/pages', { params })
        .then(result => {
          this.pages = result.data['hydra:member']
          this.pagination.updateData(result.data)
        })
        .catch(error => {
          console.info(error)
        })
    },
    askDelete (faqId) {
      this.showDeleteDialog = true
      this.deletingId = faqId
    },

    cancelDelete () {
      this.showDeleteDialog = false
      this.deletingId = null
    },

    confirmDelete () {
      if (!this.deletingId) {
        return
      }

      const api = getApiClient(this.$store)

      api.delete(this.deletingId)
        .then(result => {
          if (result.status === 204) {
            this.$store.commit('app/raiseSuccess', 'Página excluída')
            this.loadPages()
          }
        })
        .catch(() => {
          this.$store.commit('app/raiseError', 'Erro ao excluir página')
          this.loadPages()
        })
        .finally(() => {
          this.cancelDelete()
        })
    },
  },
}
